import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import OnboardingLayout from 'components/OnboardingLayout';
import { useGlobalState } from 'hooks/useGlobalState';
import { signupStatus, pingTimeoutError } from 'utils/constants';
import { getPingUrl, pingHost } from './util';

const INSTANCE_READY = 'ready';

export default function AwaitProvision() {
  const [instanceStatus, setInstanceStatus] = useState('');
  const [{ signup }, dispatch] = useGlobalState();
  const navigate = useNavigate();
  const { instanceUrl, status } = signup;
  const pingUrl = getPingUrl(instanceUrl);

  useEffect(() => {
    if (status === signupStatus.complete) {
      const successCallback = () => {
        setInstanceStatus(INSTANCE_READY);
      };
      const errorCallback = () => {
        dispatch({
          type: 'SIGNUP_ERROR',
          payload: pingTimeoutError,
        });
        dispatch({
          type: 'SET_WAITING_SCREEN_VISIBLE',
          payload: false,
        });
        navigate('/');
      };

      pingHost(pingUrl, successCallback, errorCallback);
    }
  }, [dispatch, navigate, instanceUrl, setInstanceStatus, pingUrl, status]);

  useEffect(() => {
    if (instanceStatus === INSTANCE_READY) {
      window.location.replace(instanceUrl);
    }
  }, [instanceStatus, instanceUrl]);

  return (
    <OnboardingLayout
      promptEnabled={
        [signupStatus.complete, signupStatus.pending].includes(status) &&
        instanceStatus !== INSTANCE_READY
      }
    ></OnboardingLayout>
  );
}
